import React, { useState } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, Button } from '@material-ui/core';
import { makeURL } from '../../helperFunctions';
import CircularProgress from '@material-ui/core/CircularProgress';
import useViewportWidth from 'myHooks/useViewportWidth';

const themeColorConfig = {
  green: {
    backgroundColor: '#19989B',
    hoverBackgroundColor: '#19878a',
  },
  yellow: {
    backgroundColor: '#AB8628',
    hoverBackgroundColor: '#967217',
  },
  red: {
    backgroundColor: '#E45589',
    hoverBackgroundColor: '#a3375f',
  },
};

const useStyles = makeStyles(theme => ({
  exportButtonWrapper: {
    display: 'flex',
    flexDirection: 'row-reverse',
    backgroundColor: '#FFF',
    paddingTop: '20px',
    paddingBottom: '20px',
    paddingRight: '20px',
  },
  exportButton: props => ({
    display: 'flex',
    padding: '7px 15px',
    borderRadius: '5px',
    alignItems: 'center',
    justifyContent: 'space-around',
    backgroundColor: themeColorConfig[props.type].backgroundColor,
    width: '190px',
    height: '40px',

    '&.MuiButton-root:hover.Mui-disabled': {
      backgroundColor: themeColorConfig[props.type].backgroundColor,
      color: '#fff !important',
    },

    '&.MuiButton-root.Mui-disabled': {
      backgroundColor: themeColorConfig[props.type].backgroundColor,
      color: '#fff !important',
    },

    '&:hover': {
      backgroundColor: themeColorConfig[props.type].hoverBackgroundColor,
    },

    '@media (max-width: 768px)': {
      width: '40px',
      justifyContent: 'center',
      marginRight: '6px',
    },
  }),
  exportButtonImage: {
    width: '25px',
    marginRight: '15px',

    '@media (max-width: 768px)': {
      marginRight: '0',
    },
  },
  exportButtonText: {
    color: 'white',
    fontSize: '12px',
    margin: 0,

    '@media (max-width: 768px)': {
      display: 'none',
    },
  },
}));

const PDFExportButton = ({ contentRef, type }) => {
  const classes = useStyles({ type });
  const [isLoading, setIsLoading] = useState(false);
  const width = useViewportWidth();

  const handleExport = () => {
    setIsLoading(true);
    // Get the content to be exported

    const content = contentRef.current;

    const options = {
      scale: 1.5,
      windowWidth: 816,
      logging: true,
    };
    // Use html2canvas to capture the content as an image
    html2canvas(content, options).then(canvas => {
      canvas.toBlob(canvasBlob => {
        const imgObjectUrl = URL.createObjectURL(canvasBlob);
        // Create a PDF instance
        const pdfOptions = {
          orientation: 'p',
          unit: 'px',
          format: [816, canvas.height],
          putOnlyUsedFonts: false,
          compress: true,
        };
        const pdf = new jsPDF(pdfOptions);

        // Add the captured image to the PDF
        pdf.addImage(imgObjectUrl, 'JPEG', 0, 0, pdf.internal.pageSize.width, pdf.internal.pageSize.height);

        // Save the PDF
        pdf.save('exported-file.pdf');
        setIsLoading(false);
        exportBtn.innerHTML = 'EXPORT AS PDF';
      });
    });
  };

  return (
    <Box className={classes.exportButtonWrapper}>
      <Button onClick={handleExport} className={classes.exportButton} disabled={isLoading}>
        {isLoading && width < 768
          ? '...'
          : !isLoading && (
              <img alt="export-as-pdf" src={makeURL('/images/export-pdf-icon.png')} className={classes.exportButtonImage} />
            )}
        <Typography component="div" variant="button" className={classes.exportButtonText} id="exportBtn">
          {isLoading ? 'EXPORTING...' : 'EXPORT AS PDF'}
        </Typography>
      </Button>
    </Box>
  );
};

export default PDFExportButton;
